<template>

  <v-container fluid class="mt-0 page page-vehicle-lot">

    <!-- Breadcrumb & Actions -->
    <v-row class="mt-4">
      <v-col cols="8" class="d-flex align-center justify-start page-breadcrumb-new">
        <!-- (breadcrumb) -->
        <v-icon small class="mr-2">mdi-parking</v-icon>
        <div>Vehicle Lot</div>
      </v-col>
      <v-col cols="4" align="right">
        <!-- (edit action) -->
        <v-btn color="orange darken-3" v-if="canEdit" @click="editItem">
          Edit Vehicle Lot
        </v-btn>
      </v-col>
    </v-row>

    <!-- (data loading) -->
    <v-container v-if="isDataLoading" class="d-flex flex-column align-center justify-center">
      <v-progress-circular indeterminate :size="50" style="margin-top:30px" color="primary" />
    </v-container>

    <template v-else-if="vehicleLot">
      <!---------------->
      <!-- Page Title -->
      <!---------------->
      <v-row class="mt-8 mb-4">
        <v-col cols="12">
          <div class="page-title">Vehicle Lot</div>
        </v-col>
      </v-row>

      <!------------------------->
      <!-- Vehicle Lot Details -->
      <!------------------------->
      <v-container fluid class="mt-2 page-content">
        <!-- Lot name -->
        <v-row class="pa-0 ma-0">
          <v-col cols="12" xs="12" sm="12" md="3" lg="2">
            <span class="attr-label">Name:</span>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="9" lg="10">
            <span>{{ vehicleLot.name }}</span>
          </v-col>
        </v-row>

        <!-- Address -->
        <v-row class="pa-0 ma-0 mt-3">
          <v-col cols="12" xs="12" sm="12" md="3" lg="2">
            <span class="attr-label">Address:</span>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="9" lg="10">
            <div>{{ multiLineAddress.street_1 }}</div>
            <span v-if="multiLineAddress.street_2">,</span> {{ multiLineAddress.street_2 }}
            <template v-if="multiLineAddress.area">{{ multiLineAddress.area }}</template>
          </v-col>
        </v-row>

        <!-- Status -->
        <v-row class="pa-0 ma-0 mt-3" align="center">
          <v-col cols="12" xs="12" sm="12" md="3" lg="2">
            <span class="attr-label">Status:</span>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="9" lg="10">
            <v-chip label outlined :class="vehicleLot.vehicle_lot_status" v-if="vehicleLot.vehicle_lot_status">
              {{ vehicleLot.vehicle_lot_status.toUpperCase() }}
            </v-chip>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <!-- Not Configured Message -->
    <template v-else>
      <v-row class="mt-8 mb-4">
        <v-col cols="12" align="center" justify="center">
          <div>A vehicle lot will be registered when a shipper account is created.</div>
        </v-col>
      </v-row>
    </template>

  </v-container>

</template>

<script>
export default {
  name: 'VehicleLotItemPage',

  data () {
    return {
      isDataLoading: false,
      dataLoadingError: null,
      vehicleLot: null
    }
  },

  computed: {
    uiType () {
      return this.$root.uiType()
    },
    canEdit () {
      return this.vehicleLot && this.uiType === 'shipper' && this.$root.activeUserHasRole('admin')
    },
    multiLineAddress () {
      return (this.vehicleLot)
        ? this.$root.utils.getAddressTextFromData(this.vehicleLot, { multi_lines: true })
        : {}
    }
  },

  async beforeMount () {
    this.loadItem()
  },

  methods: {
    // Navigate to edit page
    editItem () {
      this.$root.goTo('vehicle-lot-edit', { vehicleLotId: this.vehicleLot.id })
    },

    async loadItem () {
      this.isDataLoading = true

      try {
        const results = await this.$store.dispatch('sh/dataApi', {
          method: 'get',
          uri: 'vehicle-lots'
        })

        this.vehicleLot = results.items.length > 0 ? results.items[0] : null
      } catch (err) {
        this.dataLoadingError = err.message || err.text || err
      } finally {
        this.isDataLoading = false
      }
    }
  }
}
</script>

<style scoped>
</style>
